export const numberToFormatedString = (number) =>
  String(number).replace(/(?!^)(?=(?:\d{3})+(?:\.|$))/gm, ' ');
